import { SimpleDialog } from 'components';
import { Grid, Button } from '@mui/material';
export default function RejectDescrptionMessageDialog({ isOpenDialog, setIsOpenDialog, data }) {
  return (
    <SimpleDialog fullWidth maxWidth="sm" open={isOpenDialog} title="علت رد درخواست">
      <Grid
        container
        style={{
          textAlign: 'justify',
          height: `${String(data.rejectReason).length > 300 && '100px'}`,
          overflowY: `${String(data.rejectReason).length > 300 && 'auto'}`,
          padding: '0 8px',
        }}
      >
        {data.rejectReason || 'موردی ثبت نشده است.'}
      </Grid>
      <Grid style={{ display: 'flex', marginTop: '16px', flexDirection:'row-reverse'}}>
        <Button
          variant="contained"
          onClick={() => setIsOpenDialog(false)}
        >
          بستن
        </Button>
      </Grid>
    </SimpleDialog>
  );
}
